
            const data = {"name":"glyph/10/triangle-up","data":{"width":"8","height":"4","viewBox":"0 0 8 4","data":"<path pid=\"0\" _fill=\"#272c33\" fill-rule=\"nonzero\" d=\"M.5 4h7L4 0z\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    